import React from 'react';
import type User from '@this/domain/user/user';

interface Props {
  user: User;
}

const OrganizationError: React.FC<Props> = ({ user }) => {
  return (
    <div style={{ color: '#a72c09', fontSize: '15px', padding: '10px' }}>
      {user && user.department ? (
        <div>
          「{user.department.name}
          」に事前申請の承認者が設定されていません。管理者に連絡して承認者の設定を依頼してください。
        </div>
      ) : (
        <div>所属部署が設定されていません。管理者に連絡して所属部署の設定を依頼してください。</div>
      )}

      <div style={{ marginTop: '20px' }}>■ {user.organization.name}の管理者</div>
      {user.organization.admins?.map(row => (
        <div key={row.email} style={{ padding: '2px 10px' }}>
          {row.name}:{row.email}
        </div>
      ))}
    </div>
  );
};

export default OrganizationError;
